import {
  LoginPasswordInputBlock,
  LoginUsernameInputBlock,
} from '@setplex/arcana'
import { useForm } from 'effector-forms'
import { useUnit } from 'effector-react'
import { useCallback, type ChangeEvent } from 'react'
import { model as signInByEmailModel, translations } from '../model'

export const LoginPasswordInputs = ({
  pending,
}: {
  pending: boolean
}): JSX.Element => {
  const { fields, hasError, errorText } = useForm(signInByEmailModel.signInForm)
  const formTranslations = useUnit(translations.$loginPasswordTranslations)

  const handleChangeUsername = useCallback(
    (e: ChangeEvent<HTMLInputElement>) =>
      fields.username.onChange(e.target.value),
    [fields.username]
  )
  const handleChangePassword = useCallback(
    (e: ChangeEvent<HTMLInputElement>) =>
      fields.password.onChange(e.target.value),
    [fields.password]
  )
  const usernameErrorMessage = hasError('username')
    ? errorText('username', formTranslations.emailErrors)
    : ''
  const passwordErrorMessage = hasError('password')
    ? errorText('password', formTranslations.passwordErrors)
    : ''

  return (
    <>
      <LoginUsernameInputBlock
        value={fields.username.value}
        label={formTranslations.emailLabel}
        placeholder={formTranslations.emailPlaceholder}
        autoComplete='username'
        disabled={pending}
        onChange={handleChangeUsername}
        errorMessage={usernameErrorMessage}
      />
      <LoginPasswordInputBlock
        value={fields.password.value}
        label={formTranslations.passwordLabel}
        placeholder={formTranslations.passwordPlaceholder}
        autoComplete='current-password'
        disabled={pending}
        onChange={handleChangePassword}
        errorMessage={passwordErrorMessage}
      />
    </>
  )
}
